import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthHeader from '../layout/AuthHeader';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    
    try {
      await resetPassword(email);
      setMessage('Password reset email sent! Check your inbox.');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthHeader />
      <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4 pt-20 transition-colors duration-200 select-none">
        <h1 className="text-3xl font-bold text-foreground mb-8 select-none">Reset Your ThatAIHumanizer Password</h1>
        
        <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-lg p-6">
          {error && (
            <div className="mb-4 p-3 bg-destructive/10 border border-destructive/20 text-destructive rounded select-none">
              {error}
            </div>
          )}
          
          {message && (
            <div className="mb-4 p-3 bg-green-100 border border-green-200 text-green-700 rounded select-none">
              {message}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground mb-1">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-1 focus:ring-ring bg-background text-foreground placeholder:text-muted-foreground"
                placeholder="Enter your email address"
                required
                autoComplete="email"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 border border-transparent rounded-md text-primary-foreground bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring disabled:opacity-50 transition-colors"
            >
              {loading ? 'Sending...' : 'Send Password Reset Email'}
            </button>
            
            <div className="flex justify-between mt-3 text-sm">
              <a href="/login" className="text-primary hover:text-primary/80 transition-colors">
                Back to Login
              </a>
              <a href="/register" className="text-primary hover:text-primary/80 transition-colors">
                Create an Account
              </a>
            </div>
          </form>
        </div>
        
        <div className="mt-4 text-center text-sm text-muted-foreground select-none">
          We'll send you an email with a link to reset your password.
        </div>
      </div>
    </>
  );
} 